import { getSubIcon } from '@app-helpers/functions';
import * as moment from 'moment';
import { CourseModel } from './course';
import { TeacherModel } from './teacher';

export class ClassModel {
  id: any;
  subject: any;
  subjectIcons?: any = null;
  title: string = '';
  teacher: TeacherModel;
  schedule?: any = {};
  scheduleTimeStamp?: any = null;
  objectives: Array<string> = [];
  duration?: any;
  grade: number = 0;
  exams: Array<string> = [];
  boards: Array<string> = [];
  global: boolean = false;
  status: string = '';
  notes?: Array<any> = [];
  assignments: Array<any> = [];
  subscription: string = '';
  meeting: any;
  meetingStatus: string;
  recording: Array<any> = [];
  recordingids:Array<any>=[];
  featureDescription: string = '';
  updatedBy: any;
  createdBy: any;
  classStatus: any;
  isFeatured: boolean = false;
  language = 'English';
  course: any = null;
  serverTime?: any;
  isRegisteredForClass = false;
  registeredStudent: number;
  attendyStudent: number;
  media: any = null;
  classReview: string;
  teacherDisconnected: boolean;
  allowRecordedClassVisibility?:boolean;
  isRecordedClass?:boolean;
  classSource: any
  getSubIcon = getSubIcon;
  classtype: any;
  feedbackValue: Number = 0;
  recordings: any;
  chatChannelName:any
  constructor(public obj: any) {
    this.id = obj && obj.id ? obj.id : obj._id?obj._id:'';
    this.subject = obj.subject ? this.getSubIcon(obj.subject) : '';
    this.title = obj?.name || '';
    this.teacher = this.getTeacherDetails(obj?.teacher);
    if(!obj.isRecordedClass || obj?.classSource?.type == 'youtube'){
    this.schedule = {
      startDate: moment.unix(obj.startDate).format(),
      startTime: moment.unix(obj.startTime).format(),
      endTime: moment.unix(obj.endTime).format(),
      endDate: moment.unix(obj.endDate).format(),
      serverTime: obj.serverTime
        ? moment.unix(obj.serverTime)
        : obj.utcTime
        ? moment.unix(obj.utcTime)
        : moment().utc().unix(),
    };
    this.scheduleTimeStamp = {
      startDate: obj.startDate,
      startTime: obj.startTime,
      endTime: obj.endTime,
      endDate: obj.endDate,
    };
    this.duration = obj?.timeDuration || 0;
    }
    this.objectives = obj?.objectives || [];
    this.grade = obj?.grade || 0;
    this.exams = obj?.exams || [];
    this.boards = obj?.boards || [];
    this.global = obj?.global || false;
    this.status = obj?.status || 'active';
    this.notes = obj?.media?.notes?.length > 0 ? obj?.media?.notes : [];
    this.assignments =
      obj?.media?.assignments?.length > 0 ? obj?.media?.assignments : [];
    this.subscription = obj?.subscription || 'FREE';
    this.meeting = this.getMeetingDetails(obj?.meeting);
    this.meetingStatus = obj?.meetingStatus || 'waiting';
    this.recording = this.getRecording(obj?.recording) || [];
    this.updatedBy = obj?.updatedBy || {};
    this.createdBy = obj?.createdBy || {};
    this.featureDescription = obj?.featureDescription;
    this.classStatus = this.getClassStaus(obj?.classStatus);
    this.isFeatured = obj?.isFeatured;
    this.serverTime = obj?.serverTime || obj?.utcTime;
    this.isRegisteredForClass =
      obj?.isRegisteredForClass || obj?.isRegistered || false;
    this.language = obj?.language || 'English';
    this.registeredStudent = obj?.totalRegisterStudent || 0;
    this.attendyStudent = obj?.totalAttendyStudent || 0;
    this.media = this.getClassMedia(obj?.media);
    this.course =
      obj?.course && obj?.course != undefined
      ?obj.course: obj?.course?new CourseModel(obj.course)
      : null;
      if(!obj.isRecordedClass){
        this.subjectIcons = this.getSubjectIcons();
      }
    this.classReview = obj?.classReview || '';
    this.teacherDisconnected = obj?.teacherDisconnected || false;
    this.allowRecordedClassVisibility = obj?.allowRecordedClassVisibility || false;
    this.classtype = obj?.classtype;
    this.recordingids = this.getRecordingids(obj?.recording) || [];
    this.feedbackValue = obj?.feedbackValue || 0;
    this.isRecordedClass = obj?.isRecordedClass ? obj?.isRecordedClass :false;
    this.classSource = obj?.classSource;
    this.recordings = obj?.recording;
    this.chatChannelName = obj?.chatChannelName;
  }

  getTeacherDetails(_teacher: any = null) {
    if (_teacher && _teacher != undefined) {
      let _teacherObj: any;
      if (Array.isArray(_teacher) && _teacher.length > 0) {
        _teacherObj = _teacher[0];
      } else {
        _teacherObj = _teacher;
      }

      return new TeacherModel(_teacherObj);
    } else {
      return null;
    }
  }

  getClassStaus(status: any) {
    switch (status) {
      case 'upcoming':
        return 'comingup';
        break;
      case 'past':
        return 'rewatch';
        break;
      case 'free':
        return 'register';
        break;
      case 'recommended':
        return 'register';
        break;

      default:
        return 'register';
        break;
    }
  }

  getSubjectIcons() {
    if (this.subject != '') {
      let _obj: any = {
        icon: '',
        largeIcon: '',
        smallIcon: '',
      };
      let _url: string = '';

      //for medium icon
      _url = `/assets/img/subject-icons/${this.subject.toLowerCase()}-icon.svg`;
      if (this.checkImage(_url)) {
        _obj.icon = _url;
      } else {
        _url = `/assets/img/subject-icons/${this.subject.toLowerCase()}-icon.png`;
        if (this.checkImage(_url)) {
          _obj.icon = _url;
        }
      }

      //for large icon
      _url = `/assets/img/subject-icons/${this.subject.toLowerCase()}-large-icon.svg`;
      if (this.checkImage(_url)) {
        _obj.largeIcon = _url;
      } else {
        _url = `/assets/img/subject-icons/${this.subject.toLowerCase()}-large-icon.png`;
        if (this.checkImage(_url)) {
          _obj.largeIcon = _url;
        }
      }

      //for subject small icon
      _url = `/assets/img/subject-icons/${this.subject.toLowerCase()}-small-icon.svg`;
      if (this.checkImage(_url)) {
        _obj.smallIcon = _url;
      } else {
        _url = `/assets/img/subject-icons/${this.subject.toLowerCase()}-small-icon.png`;
        if (this.checkImage(_url)) {
          _obj.smallIcon = _url;
        }
      }
      return _obj;
    } else {
      return null;
    }
  }

  checkImage(url: any) {
    if (url) {
      var req = new XMLHttpRequest();
      req.open('GET', url, false);
      req.send();
      return req.status == 200;
    } else {
      return false;
    }
  }

  getRecording(_rec: any) {
    if (
      _rec &&
      _rec != undefined &&
      _rec?.s3_shared_url != undefined &&
      Array.isArray(_rec.s3_shared_url) &&
      _rec?.s3_shared_url?.length > 0
    ) {
      // return _rec;

      let _recordingArray = [];

      for (let item of _rec.s3_shared_url) {
        _recordingArray.push({
          sources: item.Location,
          thumb: '',
          title: '',
        });
      }
      return _recordingArray;
    } else {
      return null;
    }
  }

  getRecordingids(_rec){
    if (
      _rec &&
      _rec?.recording_files &&
      Array.isArray(_rec?.recording_files) &&
      _rec?.recording_files?.length > 0
    ) {
      let _recordingArray = [];

      for (let item of _rec?.recording_files) {
        _recordingArray.push({
          recordId: item?.recordId,
        });
      }
      return _recordingArray;
    } else {
      return null;
    }
  }

  getClassMedia(_objMedia: any = null) {
    let _videos = [];
    let _audios = [];
    let _documents = [];
    let _presentations = [];
    let _notes = [];

    if (
      _objMedia?.presentations != undefined &&
      _objMedia?.presentations?.length > 0
    ) {
      for (const _item of _objMedia?.presentations) {
        let _obj: any = Object.assign({}, _item);
        _obj.errorSrc = '/assets/img/presentations-large-icon.svg';
        _obj.thumb = _item.thumbnail;

        _presentations.push(_obj);
      }
    }
    if (_objMedia?.videos != undefined && _objMedia?.videos?.length > 0) {
      for (const _item of _objMedia?.videos) {
        let _obj: any = Object.assign({}, _item);
        _obj.errorSrc = '/assets/img/video-large-icon.svg';
        _obj.thumb = _item.thumbnail;

        _videos.push(_obj);
      }
    }
    if (_objMedia?.audios != undefined && _objMedia?.audios?.length > 0) {
      for (const _item of _objMedia?.audios) {
        let _obj: any = Object.assign({}, _item);
        _obj.errorSrc = '/assets/img/audio-large-icon.svg';
        _obj.thumb = _item.thumbnail;

        _audios.push(_obj);
      }
    }
    if (_objMedia?.documents != undefined && _objMedia?.documents?.length > 0) {
      for (const _item of _objMedia?.documents) {
        let _obj: any = Object.assign({}, _item);
        _obj.errorSrc = '/assets/img/document-large-icon.svg';
        _obj.thumb = _item.thumbnail;

        _documents.push(_obj);
      }
    }

    if (_objMedia?.notes != undefined && _objMedia?.notes?.length > 0) {
      for (const _item of _objMedia?.notes) {
        let _obj: any = Object.assign({}, _item);
        _obj.errorSrc = '/assets/img/document-large-icon.svg';
        _obj.thumb = _item.thumbnail;

        _notes.push(_obj);
      }
    }

    return {
      presentations: _presentations,
      videos: _videos,
      audios: _audios,
      documents: _documents,
      notes: _notes,
    };
  }

  getMeetingDetails(_meetingObj: any = null) {
    if (_meetingObj && _meetingObj != undefined) {
      if (Array.isArray(_meetingObj)) {
        return Object.assign({}, _meetingObj[0]);
      } else {
        return _meetingObj;
      }
    } else {
      return _meetingObj;
    }
  }
}
